import React, { Component } from 'react';
import classes from './Orders.css';
import axios from '../../axios-orders';
import Order from '../../components/Order/Order';
import OrderDetailPage from '../../components/Order/OrderDetailPage/OrderDetailPage';
import { Route, Switch, withRouter } from 'react-router-dom';
import Spinner from '../../components/UI/Spinner/Spinner';
import PageErrorMessage from '../../components/miscUtility/pageErrorMessage/PageErrorMessage';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actions/index';
import Button from '../../components/UI/Button/Button';

class Orders extends Component {
  componentDidMount() {
    setTimeout(() => {
      if (this.props.token) {
        this.props.GetOrders(this.props.token, this.props.userId);
      }
    }, 0)
  }

  componentDidUpdate() {
    if (localStorage.getItem('expirationDate') && (new Date(localStorage.getItem('expirationDate')).getTime() <= new Date().getTime())) {
      this.props.Logout();
    }
  }

  componentWillUnmount() {
    if (this.props.error) {
      this.props.ClearPageError();
    }
  }



  render() {
    let orders = <Spinner center={true} />;
    if (!this.props.token) {
      orders = <div className={classes.LoginCard}>
        <p>Log in to view your past orders</p>
        <Button btnType="Orange" clicked={() => { this.props.history.push('/authenticate/login') }}>Go to login page</Button>
      </div >
    }
    if (this.props.orders) {
      if (this.props.orders.length > 0) {
        orders = this.props.orders.sort((a, b) => a.orderID - b.orderID).map((order) => {
          return <Order key={`order ${order.orderID}`} orderID={order.orderID} ingredients={order.ingredients} price={order.price} />
        })
      } else {
        orders = <div className={classes.EmptyOrdersContainer}>
          <p className={classes.EmptyOrdersMessage}>Looks like you don't have any past orders.  Head over to the build page to build and order a new burger!</p>
          <Button clicked={() => { this.props.history.push('/build') }} btnType={'Orange'}>Build a new Burger</Button>
        </div>
      }
    }



    return (
      <div className={classes.OrdersPage}>
        {this.props.error ? <PageErrorMessage /> : <div>
          <Switch>
            <Route path='/orders' exact render={() => (
              <div className={classes.Orders}>
                {orders}
              </div>
            )} />
            <Route path='/orders/:id' exact render={(props) => {
              let orderDetailPage = <Spinner center={true} />;

              if (this.props.orders) {
                let order = this.props.orders.find(order => { return order.orderID === parseInt(props.match.params.id, 10) });

                orderDetailPage = <OrderDetailPage order={order} prices={this.props.prices} />
              }
              return orderDetailPage;
            }} />
          </Switch>
        </div>}


      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders.orders,
    error: state.global.error,
    loading: state.orders.ordersLoading,
    prices: state.burger.ingredientPrices,
    token: state.auth.token,
    userId: state.auth.userId

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    GetOrders: (token, userId) => dispatch(actionCreators.getOrders(token, userId)),
    ClearPageError: () => dispatch(actionCreators.clearPageError())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withErrorHandler(Orders, axios)));


// WEBPACK FOOTER //
// ./src/containers/Orders/Orders.jsx